/**
 * packages/billing/src/platform.ts
 *
 * The single native-vs-web switch for this package. The RevenueCat SDK runs
 * on native only; web purchases go through Stripe Embedded Checkout.
 *
 * ⚠️ Compliance, not just style: web checkout must NEVER run inside the
 * Capacitor-wrapped app. Apple and Google both prohibit offering an
 * alternative purchase path from within a native app shell for digital
 * goods. `isNative()` is what keeps that true.
 */

import { Capacitor } from '@capacitor/core';

export function isNative(): boolean {
  return Capacitor.isNativePlatform();
}

export function isAndroid(): boolean {
  return Capacitor.getPlatform() === 'android';
}
